import React, { useEffect, useState } from "react";
import styles from "./ResponseReview.module.css";
import { List } from "antd";
import { TextComponent } from "../../../components";
import { PiArrowUDownLeftLight } from "react-icons/pi";
import { MdOutlineStarPurple500 } from "react-icons/md";
import { useDispatch } from "react-redux";
import { ReviewMiddleware } from "../../../Store/Middlewares/ReviewMiddleware";
import moment from "moment";
import dummyImg from '../../../assets/dummy.jpg';
const ResponseReview = () => {
  const dispatch = useDispatch()
  const [responses, setResponses] = useState([])
console.log('responseeeeeee', responses);
  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    dispatch(ReviewMiddleware.getReviewReponses())
      .then((res) => {
        setResponses(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  const dummyList = [
    {
      id: 1,
      name: "Harry",
      response: "Great review ,from your side.",
      ORname: "Mark Steve",
      originalRev:
        "Leif Floyd Photography is a professional photography studio specializing in capturing stunning moments and memories. With a keen eye for detail and a passion for storytelling,",
      rating: "4.1",
    },
    {
      id: 2,
      name: "William Mark",
      response:
        "I know you are right but according to requirement we provide all services",
      ORname: "Mark Steve",
      originalRev:
        "Leif Floyd Photography is a professional photography studio specializing in capturing stunning moments and memories. With a keen eye for detail and a passion for storytelling,",
      rating: "4.1",
    },
  ];
  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={index}>
        <TextComponent textClass={styles.name} text={item?.user_name} />
        <TextComponent textClass={styles.response} text={item?.slogan}>
          &nbsp;
          <PiArrowUDownLeftLight />
        </TextComponent>
        <div className={styles.orignalBox}>
          <div className={styles.content}>
            <img src={ item?.vendor_image ? item?.vendor_image :dummyImg}/>
            <div className={styles.contentCol}>
            <TextComponent textClass={styles.ORname} text={item?.vendor_name} />
            <TextComponent textClass={styles.originalRev} text={item?.review_response} />
            </div>
          </div>
          {/* <div className={styles.ratingBox}>
            <TextComponent textClass={styles.rating} text={"Rating"}>&nbsp;{item?.rating}</TextComponent>
            <MdOutlineStarPurple500 className={styles.starIcon} />
          </div> */}
          <div className={styles.timeBox}>
          <TextComponent textClass={styles.date}>{moment(item?.date).fromNow()}</TextComponent>
          <TextComponent textClass={styles.ratingType}>{item?.review_type}</TextComponent>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainCon}>
      <List dataSource={responses} renderItem={renderItem} />
    </div>
  );
};

export default ResponseReview;
